export type Theme = "dark" | "light";
const KEY = "insight.theme";

export function getTheme(): Theme {
  const t = localStorage.getItem(KEY);
  return t === "light" ? "light" : "dark";
}

export function applyTheme(t: Theme): void {
  document.documentElement.dataset.theme = t;
}

export function setTheme(t: Theme): void {
  localStorage.setItem(KEY, t);
  applyTheme(t);
}

export function toggleTheme(): Theme {
  const next: Theme = getTheme() === "dark" ? "light" : "dark";
  setTheme(next);
  return next;
}

// Anvend før render for å unngå flash.
applyTheme(getTheme());
